<!-- 考试页面 -->
<template>
<div class="cm_exam_body">
<div class='cm_exam_container'>
  <div class="cm_news_list_title">
        <h3>在线答题</h3>
        <span>您的位置：在线答题</span>
      </div>
  <div class="cm_exam_list" v-loading="loading" style="min-height:280px">
    <ul>
      <li v-for="item in dataList" :key="item.ID" @click="toDatail(item.EXAMPAPER_ID,item.ID)">
        <div class="flex_spacebetween">
          <h3>{{item.EXAMARRANGE_NAME}}</h3>
          <span>{{cutDate(item.INPUT_DATE)}}</span>
        </div>
        <div class="flex_spacebetween">
          <span>总分：{{item.EXAMARRANGE_TOTALSCORE}}</span>
          <span>通过分数：{{item.EXAMARRANGE_PASSSCORE}}</span>
        </div>
      </li>
    </ul>
      <div class="cm_list_pagination" v-if="totalPage>1">
    <el-pagination
  background
  layout="prev, pager, next"
  :page-count="totalPage" @current-change="httpPost(current-page)" >
</el-pagination>
  </div>
  </div>
</div>
</div>
</template>

<script>
export default {
components: {},
data() {
//这里存放数据
return {
dataList:[],
currentPage:"",
  totalPage:"",
  cData:{
    showCount:1
  },
  loading:true
};
},
//监听属性 类似于data概念
computed: {
  cutDate:function(date){
      return (date)=>date.substring(0,10)
    }
},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  toDatail(paperID,ID){
    this.$router.push({path:'/exam/'+paperID,query:{ID:JSON.stringify(ID)}})
  },
 httpPost(page) {
   if(page!=""&&page!=undefined&&page!=null&&page!=NaN){
      this.cData.currentPage = page
    }
    this.loading = true
      this.$http({
        url: this.$http.adornUrl("/requestMain/itemBankService/pubQueryExamlistByUserId.do"),
        method: 'post',
        data: this.cData
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.varList
          this.currentPage = data.data.currentPage
          this.totalPage = data.data.totalPage
          this.loading = false
        }
      });
    },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
},

}
</script>
<style scoped>
.cm_exam_body{
  display: flex;
  justify-content: center;
  align-items: center;
}
.cm_list_pagination{
  margin: 20px 0;
  width: 100%;
  display:flex;
  justify-content: center;
}
.cm_exam_container{
  margin-top: 20px;
  width: 1200px;
  background: #fff;
  padding: 0 30px;
  padding-bottom: 20px;
  min-height: 500px;
}
.cm_exam_list>ul>li{
  width: 100%;
  height: 80px;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #d8d8d8;
}
.cm_news_list_title{
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379D3;
}
.cm_news_list_title>h3{
  font-size: 20px;
  font-weight: 500;
  color: #4379D3;
}
.cm_news_list_title>span{
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.flex_spacebetween{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex_spacebetween>h3{
  width: 70%;
  font-weight: 600;
}
.flex_spacebetween span{
  font-size:14px;
  color: #817474;
}
</style>